Ext.define('SA.VectorMapThematicMapLayersProperties', {
    singleton: true,

    get(modelState) {
        return {
            choropleth: SA.VectorMapChoroplethLayerProperties.get(modelState),
            filter: SA.VectorMapFilterLayerProperties.get(modelState),
            labels: SA.VectorMapLocationLabelsLayerProperties.get(modelState),
            outlines: SA.VectorMapOutlinesLayerProperties.get(modelState)
        };
    }
});